module.exports = __webpack_public_path__ + "static/media/List_BOWL.581a1c6f.mp3";